import { Check, X } from 'lucide-react';
import React from 'react';

interface InlineEditControlsProps {
  isEditing: boolean;
  onSave: () => void;
  onCancel: () => void;
  isLoading: boolean;
  children: React.ReactNode;
}

export const InlineEditControls: React.FC<InlineEditControlsProps> = ({
  isEditing,
  onSave,
  onCancel,
  isLoading,
  children,
}) => {
  if (!isEditing) return null;

  return (
    <div className="flex items-center gap-1 animate-in fade-in zoom-in-95 duration-200">
      {children}
      <div className="flex items-center gap-0.5 ml-1">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onSave();
          }}
          disabled={isLoading}
          className="h-5 w-5 hover:bg-green-100 rounded flex items-center justify-center transition-colors"
          type="button"
        >
          <Check className="h-3 w-3 text-green-600" />
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onCancel();
          }}
          disabled={isLoading}
          className="h-5 w-5 hover:bg-red-100 rounded flex items-center justify-center transition-colors"
          type="button"
        >
          <X className="h-3 w-3 text-red-600" />
        </button>
      </div>
    </div>
  );
};
